import { JSX, PropsWithChildren, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { Text } from '@videoblocks/design-system';

export interface GenerationFlowLayoutProps extends PropsWithChildren {
    className?: string;
    title: string;
    subtitle: string;
    icon?: ReactNode;
}

export const GenerationFlowLayout = ({
    className,
    title,
    subtitle,
    children,
    icon,
}: GenerationFlowLayoutProps): JSX.Element => {
    return (
        <div className={twMerge('size-full flex flex-col items-center justify-center', className)}>
            <div className="flex flex-col items-center gap-2">
                {icon}
                <div className="text-center max-w-82.5">
                    <Text>{title}</Text>
                    <Text fontSize="sm" fontWeight="regular">
                        {subtitle}
                    </Text>
                </div>
            </div>
            {children}
        </div>
    );
};
